import { createTypes } from 'reduxsauce'
 
export default createTypes(`
    GET_CONTRACT_REVIEW_INITIAL_DATA
`, {}) // options - the 2nd parameter is optional
